import * as Yup from "yup";

export const connectLinkedInCredentialsSchema = Yup.object({
  email: Yup.string().email("Enter a valid email").required("Email is required"),
  password: Yup.string().required("Password is required"),
  inboxPrivacy: Yup.string().required("Please select an inbox privacy option"),
  country: Yup.string().required("Please select a country"),
});

